// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { LazyImageStyleProps } from "@store/MobiusOverrides/LazyImage/LazyImage";
import { lazyLoadStyles } from "@store/Themes/common/mixins/lazyload";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const lazyImage: Styleguide["lazyImage"] = {
    defaultProps: {
        css: css<LazyImageStyleProps>`
            ${x => (!x.hideLoading && !x.loaded ? lazyLoadStyles() : null)}
            color: ${getColor("text.accent")};
            text-align: center;
        ` as any,
    },
};

export default lazyImage;
